module.exports = __webpack_public_path__ + "img/boiling-green-patch-mask.b82fd591.png";